import { FilterItem, FilterTypes, IFilterOption } from '@shared/models/filters';
import { appDatePresets } from '../../../app.config';

export const enquiryEventTypeOptions: IFilterOption[] = [
  { id: 'enquiry-events-all', name: 'All', value: 'all', selected: true },
  { id: 'enquiry-events-anniversary', name: 'Anniversary', value: 'ANNIVERSARY', selected: false },
  { id: 'enquiry-events-birthday', name: 'Birthday Party', value: 'BIRTHDAY_PARTY', selected: false },
  { id: 'enquiry-events-charity', name: 'Charity Event', value: 'CHARITY_EVENT', selected: false },
  { id: 'enquiry-events-children', name: "Children's Party", value: 'CHILDRENS_PARTY', selected: false },
  { id: 'enquiry-events-christening', name: 'Christening', value: 'CHRISTENING', selected: false },
  { id: 'enquiry-events-corporate', name: 'Corporate Event', value: 'CORPORATE_EVENT', selected: false },
  { id: 'enquiry-events-education', name: 'Education', value: 'EDUCATION_EVENT', selected: false },
  { id: 'enquiry-events-festival', name: 'Festival', value: 'FESTIVAL', selected: false },
  { id: 'enquiry-events-hen', name: 'Hen Party', value: 'HEN_PARTY', selected: false },
  { id: 'enquiry-events-stag', name: 'Stag Party', value: 'STAG_PARTY', selected: false },
  { id: 'enquiry-events-wedding', name: 'Wedding', value: 'WEDDING', selected: false },
  { id: 'enquiry-events-party', name: 'Party', value: 'UNSPECIFIED_EVENT', selected: false },
  { id: 'enquiry-events-other', name: 'Something Else', value: 'OTHER_PARTY', selected: false }
];

export const enquiryGuestOptions: IFilterOption[] = [
  { id: 'enquiry-guests-all', name: 'All', value: 'all', selected: true },
  { id: 'enquiry-guests-10', name: '1-10', value: '10', selected: false },
  { id: 'enquiry-guests-20', name: '11-20', value: '20', selected: false },
  { id: 'enquiry-guests-30', name: '21-30', value: '30', selected: false },
  { id: 'enquiry-guests-40', name: '31-40', value: '40', selected: false },
  { id: 'enquiry-guests-50', name: '41-50', value: '50', selected: false },
  { id: 'enquiry-guests-75', name: '51-75', value: '75', selected: false },
  { id: 'enquiry-guests-100', name: '76-100', value: '100', selected: false },
  { id: 'enquiry-guests-150', name: '101-150', value: '150', selected: false },
  { id: 'enquiry-guests-200', name: '151-200', value: '200', selected: false },
  { id: 'enquiry-guests-300', name: '201-300', value: '300', selected: false },
  { id: 'enquiry-guests-400', name: '300+', value: '400', selected: false }
];

export const ENQUIRY_FILTERS: FilterItem[] = [
  {
    id: 'filter_enquiry_services',
    name: 'Services',
    description: 'Filter by requested services',
    icon: 'ate-tag-v2',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: [],
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_enquiry_eventDate',
    name: 'Event Date',
    description: null,
    icon: 'ate-calendar-v2',
    type: FilterTypes.DATERANGE_PICKER,
    active: true,
    options: appDatePresets,
    options_selected: 0,
    filters_applied_message: 'Any',
    data: null
  },
  {
    id: 'filter_enquiry_eventType',
    name: 'Event Type',
    description: 'Filter by event type',
    icon: 'ate-birthday-cake',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: enquiryEventTypeOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_enquiry_guests',
    name: 'Number of Guests',
    description: 'Filter by guest count',
    icon: 'ate-guests',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: enquiryGuestOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_enquiry_search',
    name: 'Search',
    type: FilterTypes.SEARCH,
    active: false,
    options: null,
    options_selected: 0,
    value: ''
  }
];
